<template>
  <div class="container-title">
    <h1 v-if="level == 1" class="title-size-cleed h1-title-size-cleed" level="1">
      {{ title }}
    </h1>
    <h2 v-else-if="level == 2" class="title-size-cleed h2-title-size-cleed" level="2">
      {{ title }}
    </h2>
    <h3 v-else-if="level == 3" class="title-size-cleed h3-title-size-cleed" level="3">
      {{ title }}
    </h3>
    <h4 v-else-if="level == 4" class="title-size-cleed h4-title-size-cleed" level="4">
      {{ title }}
    </h4>
    <h5 v-else-if="level == 5" class="title-size-cleed h5-title-size-cleed" level="5">
      {{ title }}
    </h5>
    <h6 v-else-if="level == 6" class="title-size-cleed h6-title-size-cleed" level="6">
      {{ title }}
    </h6>
    <h6 v-else-if="level == 7" class="title-size-cleed h7-title-size-cleed" level="6">
      {{ title }}
    </h6>
  </div>
</template>
<script>

export default {
  name: "Title",
  props: {
    title: {
      type: String,
      default: "",
    },
    level: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style scoped>
.h1-title-size-cleed {
  font-size: 26px;
}
.h2-title-size-cleed {
  font-size: 24px;
  margin: 0px 20px;
}
.h3-title-size-cleed {
  font-size: 19px;
}
.h4-title-size-cleed {
  font-size: 18px;
}
.h5-title-size-cleed {
  font-size: 17px;
}
.h6-title-size-cleed {
  font-size: 1rem;
}

.h7-title-size-cleed {
  font-size: 14px;
  font-weight: 500;
  font-style: italic;
}

@media (max-width: 450px) {
  .h2-title-size-cleed {
    font-size: 20px;
    margin: 16px 36px;
  }
}
</style>